// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getBeginWeeks, getEndWeeks, getFamiliesFactory } from '../../common/repositories';
import { AllBundlesOrderedTable } from './components/all-bundles-ordered-table';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { getAllBundlesOrdered } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class AllBundlesOrdered extends Component {

    state = {

        familyTypes: [],
        beginWeeks: [],
        endWeeks: [],
        selectedFamilyType: '',
        selectedBeginWeek: '',
        selectedEndWeek: '',
        results: null
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getFamiliesFactory( 'N', 'Y' ).then( response => {

            this.setState( {
                familyTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getBeginWeeks().then( response => {

            this.setState( {
                beginWeeks: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val
        }, () => {

            this.props.increaseCounter();
            getEndWeeks( val ).then( response => {

                this.setState( {
                    endWeeks: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedFamilyType && this.state.selectedBeginWeek &&
             this.state.selectedEndWeek ) {

            this.props.increaseCounter();

            const { selectedFamilyType } = this.state;
            const { selectedBeginWeek } = this.state;
            const { selectedEndWeek } = this.state;

            getAllBundlesOrdered( selectedFamilyType.trim(), selectedBeginWeek, selectedEndWeek )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            familyTypes, beginWeeks, endWeeks, selectedFamilyType,
            selectedBeginWeek, selectedEndWeek, results
        } = this.state;

        function buildWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const beginWeekDates = beginWeeks ? beginWeeks.map( date => ( {
            label: buildWeekDate( date.beginWeek ), id: formatGivenDate( date.beginWeek, 'YYYY-MM-DD' )
        } ) ) : [];

        const endWeekDates = endWeeks ? endWeeks.map( date => ( {
            label: buildWeekDate( date.endWeek ), id: formatGivenDate( date.endWeek, 'YYYY-MM-DD' )
        } ) ) : [];

        const mapResults = [];
        let k = 1;
        let totalSumOrder = 0;
        const additionalInfo = { unitName: this.props.unit.name };

        if ( results !== null && results.allBundleOrders !== null ) {

            Object.keys( results.allBundleOrders ).forEach( item => {

                const tableResult = [];
                let totalOrder = 0;
                results.allBundleOrders[item].forEach( tempResult => {

                    totalOrder += tempResult.totalOrdered;
                    tableResult.push( tempResult );

                } );
                const tempResultWithUnitName = tableResult
                    .map( i => ( { ...i, ...additionalInfo, beginweek: item } ) );
                totalSumOrder += totalOrder;
                mapResults[k] = tempResultWithUnitName;
                mapResults[k].BeginWeek = item;
                mapResults[k].totalOrder = totalOrder;
                k += 1;

            } );

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">All Bundles Ordered</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-all-bundles-ordered-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-all-bundles-ordered-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />

                                {selectedFamilyType && (
                                    <OptionsDropDown
                                        className="atp-all-bundles-ordered-select"
                                        label="From"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleBeginWeekChange.bind( this )}
                                        optionDisplayAttributes={['label']}
                                        optionKey="id"
                                        options={beginWeekDates}
                                        placeholder="Select Begin Week"
                                        selectedValue={selectedBeginWeek}
                                        isRequired={false}
                                    />

                                )}

                                {selectedBeginWeek && (
                                    <OptionsDropDown
                                        className="atp-all-bundles-ordered-select"
                                        label="To"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['label']}
                                        optionKey="id"
                                        options={endWeekDates}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                        isRequired={false}
                                    />

                                )}

                                {selectedFamilyType && selectedBeginWeek && selectedEndWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        <section className="messagecontainer">
                            {results !== null && (
                                <div className="displaydate"> Status as of {Date()}</div>
                            ) }
                            {results !== null && (
                                <div className="displayMessage ">Total Ordering Quantity for Time Period: {totalSumOrder}</div>
                            ) }
                        </section>
                        {selectedFamilyType && selectedBeginWeek && selectedEndWeek &&
                        results !== null && mapResults.map( ( item, index ) => (
                            item !== null && item.length > 0 && (
                                <AllBundlesOrderedTable
                                    key={`all-bundles-${item.BeginWeek}-${index}`}
                                    results={item}
                                    selectedFamilyType={selectedFamilyType}
                                    totalOrder={item.totalOrder}
                                    selectedBeginWeek={formatGivenDate( Number( item.BeginWeek ), 'YYYY-MM-DD' )}
                                />
                            )
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

AllBundlesOrdered.displayName = 'AllBundlesOrdered';
AllBundlesOrdered.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( AllBundlesOrdered ) );
